export { default } from './staffDetails.container';